import React, { useState, ReactNode } from "react";
import Label from "./Label";
import Text from "./Text";
import Button from "./Button";
import Flex from "./Flex";

type SelectOption = {
    text: string;
    value: string;
    default?: boolean;
}

type ToggleButtonSelectProps = {
    label?: ReactNode;
    id?: string;
    options: SelectOption[];
    onChange?: (value: string) => void;
    name: string;
    initialValue?: string;
    leftValue?: string;
}

const LEFT_SELECTED_BTN_STYLE = {
    backgroundColor: "white",
    border: 1, 
    borderColor: "#EE7D00",
};

const RIGHT_SELECTED_BTN_STYLE = {
    backgroundColor: "white",
    border: 1,
    borderColor: "#DDDDDD",
};

const NO_SELECTED_BTN_LEFT_STYLE = {
    backgroundColor: "rgb(255, 245, 220)",
    border: 0,
    borderColor: "rgb(255, 245, 220)"
}

const NO_SELECTED_BTN_RIGHT_STYLE = {
    backgroundColor: "#F9FAFB",
    border: 0,
    borderColor: "#F9FAFB"
}
function ToggleButtonSelect({ 
    label, 
    id, 
    options,
    onChange,
    name,
    initialValue,
    leftValue = 'Y',
    ...props 
}: ToggleButtonSelectProps) {
    
    const optionUse = options[0];
    const optionNotUse = options[1];

    const defaultOptionValue = options.find(opt => opt.default)?.value 
                            ?? initialValue 
                            ?? options[0]?.value 
                            ?? "";
                            
    const [selectedValue, setSelectedValue] = useState<string>(defaultOptionValue);

    const handleButtonClick = (value: string) => {
        setSelectedValue(value);
        if (onChange) {
            onChange(value);
        }
    };
    
    const getButtonStyle = (optionValue: string) => {
        if (selectedValue !== optionValue) {
            return selectedValue === leftValue
                ? NO_SELECTED_BTN_LEFT_STYLE
                : NO_SELECTED_BTN_RIGHT_STYLE;
        }
        return selectedValue === leftValue && selectedValue == optionValue
            ? LEFT_SELECTED_BTN_STYLE 
            : RIGHT_SELECTED_BTN_STYLE
    };
    
    const getTextColor = (optionValue: string) => {
        return selectedValue === optionValue ? "black" : "rgba(85, 85, 85, 1)";
    };

    const getBgColor = (optionValue: string) => {
        return selectedValue === leftValue && selectedValue == optionValue
            ? "rgb(255, 245, 220)" 
            : "#F9FAFB"
    }

    return (
        <Flex justifyContent="space-between" alignItems="center" fullWidth>
            <Label htmlFor={id}>{label}</Label>

            <Flex 
                alignItems="center" 
                style={{ 
                    width: "220px", 
                    height: "45px", 
                    backgroundColor: getBgColor(optionUse.value),
                    borderRadius: "12px", 
                    padding: "4px",
                    boxSizing: 'border-box',
                }}
            >
                <Button 
                    width={106} 
                    height={37} 
                    borderRadius={8}
                    onClick={() => handleButtonClick(optionUse.value)}
                    {...getButtonStyle(optionUse.value)}
                >
                    <Text weight={"medium"} color={getTextColor(optionUse.value)}>
                        {optionUse.text}
                    </Text>
                </Button>

                <Button 
                    width={106} 
                    height={37} 
                    borderRadius={8} 
                    onClick={() => handleButtonClick(optionNotUse.value)}
                    {...getButtonStyle(optionNotUse.value)}
                >
                    <Text weight={"medium"} color={getTextColor(optionNotUse.value)}>
                        {optionNotUse.text}
                    </Text>
                </Button>
            </Flex>
            <input type="hidden" name={name} value={selectedValue} id={id} />
        </Flex>
    );
}

export default ToggleButtonSelect;
export type { SelectOption };